import { useMutation } from "@apollo/client/react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";

import { constantsData, statusTypesData, urlsData } from "@/data";
import { createGroupMutation } from "@/graph";
import { openAlert } from "@/redux/actions";
import { displayErrorHandler } from "@/utils";

const useCreateGroup = () => {
    const { t } = useTranslation();

    const dispatch = useDispatch();

    const navigate = useNavigate();

    const [createGroupAction, { loading }] = useMutation(createGroupMutation);

    const createGroup = async (data) => {
        try {
            await createGroupAction({
                onCompleted: () => {
                    navigate(urlsData.routes.groups.url);

                    dispatch(
                        openAlert(
                            t("messages.createMsgs.success", { entity: t("groups.entity") }),
                            statusTypesData.success,
                        ),
                    );
                },
                variables: {
                    data: {
                        group_email: data.email,
                        group_name: data.name,
                    },
                },
            });
        } catch (err) {
            displayErrorHandler(
                err.message === constantsData.failedToFetch ? t("messages.networkFailure") : err.message,
                dispatch,
                openAlert,
            );
        }
    };

    return {
        createGroup,
        loading,
    };
};

export default useCreateGroup;
